export const ACTIONS = {
  CMTSDATA: 'CMTSDATA',
  CONTENTCARDDATA: 'CONTENTCARDDATA',
  TAGS: 'TAGS',
  CONTENTSETTINGS: 'CONTENTSETTINGS',
  CONTENTTYPES: 'CONTENTTYPES',
  GROUPRADARID: 'GROUPRADARID',
  GETRADARDATAACTION: 'GETRADARDATAACTION',
  DEVPATHS: 'DEVPATHS',
  TAGACTIVATED: 'TAGACTIVATED',
  MAINACTORS: 'MAINACTORS',
  RELATEDSCENARIOS: 'RELATEDSCENARIOS',
  RELATEDSCENARIOSDATA: 'RELATEDSCENARIOSDATA',
  SCENARIOSET: 'SCENARIOSET',
  SCENARIO: 'SCENARIO',
  ACTORS: 'ACTORS',
  VERBALDRIVERS: 'VERBALDRIVERS',
  CURRENTINDEXEDITINGHISTORY: 'CURRENTINDEXEDITINGHISTORY',
  HISTORYDATA: 'HISTORYDATA',
  ORIGNALTAGS: 'ORIGNALTAGS',
  ISTRANSLATED: 'ISTRANSLATED',
  LANGLISTOPTIONS: 'LANGLISTOPTIONS',
  LANGFORTRANSSTATE: 'LANGFORTRANSSTATE',
  ISAUTOTRANS: 'ISAUTOTRANS',
  DRIVERSFUTURESTABLES: 'DRIVERSFUTURESTABLES',
  DATAFORTRANSLATIONCARDBODY: 'DATAFORTRANSLATIONCARDBODY',
  DATAFORTRANSLATIONTYPEIMAGE: 'DATAFORTRANSLATIONTYPEIMAGE',
  DATAFORTRANSLATIONFROMCARDHEADER: 'DATAFORTRANSLATIONFROMCARDHEADER',
  DEVELOPMENTPATHDOM: 'DEVELOPMENTPATHDOM',
  NARRATIVEDOM: 'NARRATIVEDOM',
  ACTORSDOM: 'ACTORSDOM',
  DRIVERSDOM: 'DRIVERSDOM',
  SET_PDF_EXPORT_LOADING: 'SET_PDF_EXPORT_LOADING',
  ISRTL: 'ISRTL',
}
